import React from 'react';
import SettingsSaveButton from '../SettingsSaveButton';
import MotorCurrencySelect from '../MotorCurrencySelect';

const STOR_EXTRA_FIELDS = [
  { key: 'jumbo', label: 'Jumbo Sistem' },
  { key: 'altEtekDilim', label: 'Alt Etek Dilim' },
  { key: 'kapaliKasa', label: 'Kapalı Kasa' },
  { key: 'altEtekLazer', label: 'Alt Etek Lazer' },
  { key: 'dekoratifLama', label: 'Dekoratif Lama' },
  { key: 'dekoratifKasa', label: 'Dekoratif Kasa' },
  { key: 'altEtekBeyazIs', label: 'Alt Etek Beyaz İş' },
];

const ZEBRA_EXTRA_FIELDS = [
  { key: 'jumbo', label: 'Jumbo Sistem' },
  { key: 'altEtekDilim', label: 'Alt Etek Dilim' },
  { key: 'kapaliKasa', label: 'Kapalı Kasa' },
];

const StorZebraSettings = React.memo(({
  extraPrices,
  setExtraPrices,
  handleSaveSettings,
  isSavingSettings,
  activeTypeTab
}) => {
  const isStor = activeTypeTab === 'stor';
  const extraFields = isStor ? STOR_EXTRA_FIELDS : ZEBRA_EXTRA_FIELDS;

  return (
    <>
      <div className="settings-card">
        <div className="settings-card-header">
          <div className="settings-card-title">
            <i className="fas fa-cogs"></i>
            <div className="settings-card-title-text">
              <h4>{isStor ? 'Stor' : 'Zebra'} Motor Ayarları</h4>
              <span className="settings-card-subtitle">
                {isStor ? 'Stor' : 'Zebra'} siparişlerinde kullanılacak motor döviz ve ücret bilgileri
              </span>
            </div>
          </div>
          <SettingsSaveButton
            onClick={() => handleSaveSettings()}
            isSaving={isSavingSettings}
          />
        </div>

        <div className="settings-fields-grid settings-fields-grid--compact">
          <div className="form-group">
            <label>Motor Döviz Kuru</label>
            <MotorCurrencySelect
              value={extraPrices.motorCurrency}
              onChange={(currency) => setExtraPrices(p => ({ ...p, motorCurrency: currency }))}
            />
          </div>
          <div className="form-group">
            <label>Motor Ücreti</label>
            <div className="settings-input-wrap">
              <input
                type="number"
                value={extraPrices.motorPrice}
                onChange={(e) => setExtraPrices(p => ({ ...p, motorPrice: e.target.value }))}
                placeholder="0"
              />
            </div>
          </div>
        </div>
      </div>

      <div className="settings-card">
        <div className="settings-card-header">
          <div className="settings-card-title">
            <i className={isStor ? 'fas fa-cog' : 'fas fa-stream'}></i>
            <div className="settings-card-title-text">
              <h4>{isStor ? 'Stor' : 'Zebra'} Perde Ücret Ayarları</h4>
              <span className="settings-card-subtitle">
                {isStor
                  ? 'Stor siparişlerinde kullanılacak sistem ve aksesuar ek ücretleri'
                  : 'Zebra siparişlerinde kullanılacak sistem ve aksesuar ek ücretleri'}
              </span>
            </div>
          </div>
          <SettingsSaveButton
            onClick={() => handleSaveSettings()}
            isSaving={isSavingSettings}
          />
        </div>

        <div className="settings-fields-grid">
          {extraFields.map(({ key, label }) => (
            <div className="form-group" key={key}>
              <label>{label}</label>
              <div className="settings-input-wrap">
                <input
                  type="number"
                  value={extraPrices[key]}
                  onChange={(e) => setExtraPrices(p => ({ ...p, [key]: e.target.value }))}
                  placeholder="0"
                />
                <span className="settings-input-suffix">₺</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
});

export default StorZebraSettings;
